import { LinearProgress } from '@mui/material';

import { useReservationFormMachines } from './ReservationFormMachinesContext';

function ReservationFormSubmitProgress() {
  const { mainSnapshot } = useReservationFormMachines();
  const isSubmitting =
    mainSnapshot.matches('submitting') || mainSnapshot.matches('validating');

  if (!isSubmitting) return null;

  return <LinearProgress />;
}

export { ReservationFormSubmitProgress };
